import type { LandingPageAppEnv } from '@lucimark/shared/helpers/landingPageUrl'
import { resolveLandingPageOrigin } from '@lucimark/shared/helpers/landingPageUrl'

function resolvePlayerLandingAppEnv(): LandingPageAppEnv {
  const mode = import.meta.env.MODE
  if (mode === 'staging') {
    return 'staging'
  }
  if (mode === 'production') {
    return 'production'
  }
  return 'development'
}

/**
 * Human-facing pairing URL for the unregistered idle screen (no scheme — TV-readable).
 * Production: `lucimark.com/r/ABCDE`. Staging / local use the landing origin host.
 */
export function buildPlayerPairingTypedUrl(
  code: string | null,
  appEnv: LandingPageAppEnv = resolvePlayerLandingAppEnv()
): string {
  const origin = resolveLandingPageOrigin(appEnv)
  const host = origin.replace(/^https?:\/\//, '').replace(/\/$/, '')
  if (code == null || code.length !== 5) {
    return host
  }
  return `${host}/r/${code}`
}
